// Data Centres Page Map
var dcMaPJs = (function () {
  function init() {
    uiBindings();
  }
  var uiBindings = function () {
    var thatParent, activeDc, activeDCList, activeTooltip;
    var dcNamesListAnchor = document.querySelectorAll(
      ".dc-names > li > button"
    );
    if (dcNamesListAnchor) {
      for (var i = 0; i < dcNamesListAnchor.length; i++) {
        dcNamesListAnchor[i].addEventListener("click", dcNamesListFn);
      }
    }
    // List items click
    function dcNamesListFn(e) {
      e.preventDefault();
      (thatParent = this.parentNode),
        (activeParentDC = document.querySelectorAll(
          "[data-active=" + thatParent.getAttribute("data-active") + "]"
        )),
        (activeDCList = document.querySelectorAll(".dc-names > li.active"));

      // Add active class to the current clicked item
      if (!thatParent.classList.contains("active")) {
        if (activeDCList.length) {
          for (var i = 0; i < activeDCList.length; i++) {
            activeDCList[i].classList.remove("active");
          }
        }
        for (var i = 0; i < activeParentDC.length; i++) {
          activeParentDC[i].classList.add("active");
        }

        // Remove active-dc class from the pulse circle
        var pulseBox = document.querySelectorAll(".pulse-dot-wrapper");
        for (var i = 0; i < pulseBox.length; i++) {
          if (pulseBox[i].classList.contains("active-dc")) {
            pulseBox[i].classList.remove("active-dc");
          }
        }

        activeDc = thatParent.getAttribute("data-active");
        document.querySelector("." + activeDc).classList.add("active-dc");
        activeTooltip = activeDc.replace("-dc", "");

        // Remove active class from tooltips
        var toolTip = document.querySelectorAll(".tooltip");
        for (var i = 0; i < toolTip.length; i++) {
          if (toolTip[i].classList.contains("show")) {
            toolTip[i].classList.remove("show");
          }
        }
        document
          .querySelector("." + activeTooltip + "-tooltip")
          .classList.add("show");
      } else {
        // do nothing
      }
    }

    // Hover event on the pulse
    var dcCircle = document.querySelectorAll(".pulse-dot");
    if (dcCircle) {
      for (var i = 0; i < dcCircle.length; i++) {
        dcCircle[i].addEventListener("mouseover", dcCircleHover);
        dcCircle[i].addEventListener("mouseleave", dcCircleLeave);
      }
    }

    function dcCircleHover(e) {
      e.preventDefault();
      var that = this,
        activePulse;
      if (that.classList.contains("active-dc")) {
        // do nothing
      } else {
        activePulse = that.parentElement.getAttribute("data-pulse");
        that.parentElement.classList.add("active-dc");
        var activeDCPulse = document.querySelectorAll(
          '.dc-names > li[data-active="' + activePulse + '"] > button'
        );
        if (activeDCPulse.length) {
          for (var i = 0; i < activeDCPulse.length; i++) {
            activeDCPulse[i].click();
          }
        }

        // Tooltip interaction
        var toolTip = document.querySelectorAll(".tooltip");

        if (toolTip) {
          for (var i = 0; i < toolTip.length; i++) {
            toolTip[i].addEventListener("mouseover", toolTipHover);
            toolTip[i].addEventListener("mouseleave", toolTipLeave);
          }
          function toolTipHover(e) {
            e.preventDefault();

            for (var i = 0; i < toolTip.length; i++) {
              if (toolTip[i].classList.contains("show")) {
                toolTip[i].classList.remove("show");
              }
            }

            this.classList.add("show");

            var dcNamesList = document.querySelectorAll(".dc-names > li");
            if (dcNamesList) {
              for (var i = 0; i < dcNamesList.length; i++) {
                if (dcNamesList[i].classList.contains("active")) {
                  dcNamesList[i].classList.remove("active");
                }
              }
            }

            var dcActiveList = document.querySelectorAll(
              '.dc-names > li[data-active="' + activePulse + '"]'
            );
            if (dcActiveList.length) {
              for (var j = 0; j < dcActiveList.length; j++) {
                dcActiveList[j].classList.add("active");
              }
            }
          }
          function toolTipLeave() {
            mouseLeave(that);
          }
        }
      }
    }

    function dcCircleLeave(e) {
      e.preventDefault();
      var that = this;
      mouseLeave(that);
    }

    // MouseLeave Function
    function mouseLeave(currentElement) {
      if (currentElement.parentElement.classList.contains("active-dc")) {
        currentElement.parentElement.classList.remove("active-dc");
      }

      var dcNamesList = document.querySelectorAll(".dc-names > li");
      if (dcNamesList) {
        for (var i = 0; i < dcNamesList.length; i++) {
          if (dcNamesList[i].classList.contains("active")) {
            dcNamesList[i].classList.remove("active");
          }
        }
      }

      var toolTip = document.querySelectorAll(".tooltip");

      if (toolTip) {
        for (var i = 0; i < toolTip.length; i++) {
          if (toolTip[i].classList.contains("show")) {
            toolTip[i].classList.remove("show");
          }
        }
      }
    }
  };

  init();
})();